import React from 'react';
import { Container, Row, Col, ListGroup } from 'react-bootstrap';

const Home = () => {
    return (
        <Container className="mt-5">
            <Row>
                <Col>
                    <h2>Monit Platform Ops</h2>

                    <h3 className="mt-4">Overview</h3>
                    <p>
                        Monit Platform Ops is intended to be a unified solution designed to increase productivity while developing solutions across our AWS infrastructure. By integrating AWS backend, Jira and GitHub, the goal is to tie these products together in a way that saves time and improves efficiency for engineers and product management.
                    </p>

                    <h3 className="mt-4">Current Features</h3>
                    <h4>Initial Release; Backend Service Status</h4>
                    <ul>
                        <li>Color coded service status; green=ok, orange=deployment in progress, red=problem</li>
                        <li>Compare deployed service versions across the company</li>
                        <li>View source code differences between releases (for GitHub-based repositories)</li>
                        <li>Mobile support</li>
                    </ul>

                    <p>To compare versions:</p>
                    <ol>
                        <li>Navigate to the cluster page</li>
                        <li>Cmd-click (MacOS) or Ctrl-Click (Windows) to select two versions</li>
                        <li>Click the comparison button to view source code differences</li>
                        <li>IMPORTANT: for repos that do not use GitHub releases, this will not work. We need to backfill some services & Terraform with versioning.</li>
                    </ol>

                    <h3 className="mt-4">Upcoming Features</h3>
                    <h4>Short-term</h4>
                    <ul>
                        <li>Visibility into deployed PRs and tickets per environment</li>
                        <li>Eliminate the need to search Jira or GitHub for deployment information</li>
                    </ul>

                    <h4>Long-term Roadmap</h4>
                    <ol>
                        <li>UI deployment tracking</li>
                        <li>Lambda deployment tracking</li>
                        <li>Terraform deployment tracking</li>
                        <li>Drag & drop version upgrades (e.g., UAT to Production)</li>
                        <li>Work summary for specific repositories over given time periods</li>
                        <li>ECS deployment history</li>
                        <li>ECS task definition comparisons</li>
                    </ol>

                    <h3 className="mt-4">Feedback</h3>
                    <p>For suggestions or feedback, please contact Rori.</p>
                </Col>
            </Row>
        </Container>
    );
};

export default Home;